module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/Users/leoth/Desktop/Leo/Programming/Hackathons/Octocite/octocite/src/app/footer.component.html
// module id = ../../../../../src/app/footer.component.html
// module chunks = main